import { Routes } from '@angular/router';
import { AUTO_ROUTES } from './app.routes.gen';
import { CeremaLayout } from '@shared/layouts/cerema-layout/components/cerema.layout';
import { EmptyLayoutComponent } from '@shared/layouts/empty-layout/empty.layout';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    ...AUTO_ROUTES,
    {
        path: '',
        component: EmptyLayoutComponent,
        children: [
            { path: 'home', loadComponent: () => import('./pages/home.page').then(m => m.HomePage) },
            { path: 'login', loadComponent: () => import('@shared/auth/login-page').then(m => m.LoginPage) },
            { path: 'deconnexion', loadComponent: () => import('@shared/auth/logout-page').then(m => m.LogoutPage) }
        ]
    },
    {
        path: 'app',
        component: CeremaLayout,
        children: []
    }
];
